export default defineNuxtPlugin(nuxtApp => {
  // TODO check if we can use the feature flag in posthog
  const config = useRuntimeConfig()

  const isAlpha = config.public.name === 'alpha'
  const isBeta = config.public.name === 'beta'
  const isApp = config.public.name === 'app'

  const features = {
    tableAdvancedSetting: isAlpha || isBeta,
    learn: isAlpha || isBeta,
    qc: isBeta || isApp,
    trainingRuns: isAlpha,
    comments: isAlpha || isBeta || isApp,
    posthogTesting: isAlpha,
    showDocStatus: isAlpha || isBeta,
    showDocStatusInTable: isAlpha || isBeta,
    dan: isAlpha || isBeta,
    hermesTest: isAlpha || isBeta,
    notifications: isAlpha || isBeta || isApp,
    cancelSubscriptions: isAlpha || isBeta,
    dataSets: isAlpha || isBeta,
    siteAnalytics: isAlpha || isBeta,
    pageTranslate: isAlpha,
    batchSummarize: isAlpha,
    labelsForModels: isAlpha || isBeta || isApp,
    structureTable: isAlpha,
    debug: isAlpha,
    projects: isAlpha,
    smartExtract: isAlpha,
    sitesTagSearch: isAlpha || isBeta || isApp,
    sitesSearchNavigation: isAlpha,
    readingOrderStyling: isAlpha || isBeta || isApp,
    fontSizeSlider: isAlpha || isBeta || isApp,
    singleImageButton: isAlpha || isBeta || isApp,
    regionCrosshairs: isAlpha || isBeta || isApp,
    whiteEditorNavbar: isAlpha || isBeta || isApp,
    tableTrainingLayers: isAlpha || isBeta || isApp,
    userStorageDisplay: isAlpha || isBeta || isApp,
    setupTour: isAlpha || isBeta,
    quickRecMultipleFiles: isAlpha || isBeta,
    shiftSelectTrainingPages: isAlpha || isBeta || isApp,
    addRegionMenu: isAlpha || isBeta || isApp,
    quickRecogNavigation: isAlpha || isBeta,
    metadataImport: isAlpha,
  }
  return {
    provide: {
      features,
    },
  }
})
